module.exports = __webpack_public_path__ + "img/b2549fc7a2c357acb811d10525df6e68.4ba531f5.png";